<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-12">
        <h2>{{ $t('dynamic_dashboards') }}</h2>
        <ol class="breadcrumb">
          <li class="active">
            <strong>{{ $t('dynamic_dashboards') }}</strong>
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="ibox float-e-margins">
            <!-- <div class="ibox-title">
              <h5>Items</h5>
            </div> -->
            <div class="ibox-content">
              <div class="wrapper-table">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ $t('name') }}</th>
                      <th class="text-center actions-lg">
                        {{ $t('view') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items" :key="item.Id">
                      <td>{{ item.Nome }}</td>
                      <td class="text-center">
                        <a
                          class="action-icon"
                          style="cursor: pointer"
                          @click="onClickView(item.Id)"
                        >
                          <i class="fa fa-download fa-eye text-navy" />
                        </a>
                      </td>
                    </tr>
                    <tr v-if="items.length === 0">
                      <td colspan="4">{{ $t('no_item_found') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Pagination
                :total="totalOfPages"
                :current="currentPage"
                :page-size="pageSize"
                @change="onPageChange"
                @pageSizeChange="onPageSizeChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { mapMutations, mapActions, mapState } from 'vuex'
import { getUserData } from '../../lib/token'
import axios from 'axios'
import hideLoading from '../../lib/hideLoading'

export default {
  name: 'DashboardDinamicoIndex',
  components: { Pagination },
  methods: {
    ...mapMutations('dashboardDinamico', ['updatePageSize']),
    ...mapActions('dashboardDinamico', ['loadAll']),
    onPageChange(page) {
      this.loadAll(page)
    },
    onPageSizeChange(size) {
      this.updatePageSize(size)
    },
    onClickView(id) {
      this.$router.push({ name: 'dashboard-dinamico-show', params: { id } })
    }
  },
  computed: {
    ...mapState('dashboardDinamico', [
      'items',
      'status',
      'currentPage',
      'totalOfPages',
      'pageSize'
    ])
  },
  beforeRouterEnter() {
    const userData = getUserData()
    if (userData) {
      const { access_token } = userData
      axios.defaults.headers.common['Authorization'] = `bearer ${access_token}`
    }
  },
  mounted() {
    document.title = `IMEA - ${this.$t('dynamic_dashboards')}`
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
    hideLoading()
    this.loadAll()
  }
}
</script>
